export { default } from './favorites-card-list';
